import { GENERIC_CONCESSION_VALIDATION_ERROR } from './concessionValidationConstants'

const keyToDisplayTitle = key =>
  String(key ?? '')
    .split('-')
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')

export const resolveConcessionLocationTitle = item => {
  const title = String(item?.title ?? item?.label ?? '').trim()
  if (title) return title
  return keyToDisplayTitle(item?.key)
}

export const getConcessionFilterOptionFieldErrors = (option = {}) => ({
  label: !String(option?.label ?? '').trim() ? 'Option title is required' : '',
  color: !String(option?.color?.value ?? '').trim() ? 'Category flag is required' : ''
})

export const getConcessionFilterCategoryFieldErrors = (options = []) => {
  const normalizedOptions = Array.isArray(options) ? options : []

  return {
    category: normalizedOptions.length === 0 ? 'At least one option is required' : '',
    options: normalizedOptions.map(option => getConcessionFilterOptionFieldErrors(option))
  }
}

export const getConcessionLocationSubsectionFieldErrors = (subsection = {}) => ({
  label: !String(subsection?.label ?? '').trim() ? 'Section label is required' : ''
})

export const getConcessionLocationItemFieldErrors = (location = {}) => ({
  title: !resolveConcessionLocationTitle(location) ? 'Location title is required' : '',
  sections: (location?.sections || []).map(section => getConcessionLocationSubsectionFieldErrors(section))
})

export const getConcessionLocationCategoryFieldErrors = (sections = []) => {
  const normalizedSections = Array.isArray(sections) ? sections : []

  return {
    category: normalizedSections.length === 0 ? 'At least one location is required' : '',
    items: normalizedSections.map(section => getConcessionLocationItemFieldErrors(section))
  }
}

export const getConcessionFiltersAdminFieldErrors = ({
  locationSections = [],
  cuisineOptions = [],
  dietaryOptions = []
} = {}) => ({
  location: getConcessionLocationCategoryFieldErrors(locationSections),
  cuisine: getConcessionFilterCategoryFieldErrors(cuisineOptions),
  dietary: getConcessionFilterCategoryFieldErrors(dietaryOptions)
})

export const hasConcessionFilterCategoryFieldErrors = (categoryErrors = {}) => {
  if (categoryErrors.category) {
    return true
  }

  return (categoryErrors.options || []).some(optionErrors =>
    Object.values(optionErrors || {}).some(Boolean)
  )
}

export const hasConcessionLocationCategoryFieldErrors = (locationErrors = {}) => {
  if (locationErrors.category) {
    return true
  }

  return (locationErrors.items || []).some(itemErrors => {
    if (itemErrors.title) {
      return true
    }

    return (itemErrors.sections || []).some(sectionErrors =>
      Object.values(sectionErrors || {}).some(Boolean)
    )
  })
}

export const hasConcessionFiltersAdminFieldErrors = (fieldErrors = {}) =>
  hasConcessionLocationCategoryFieldErrors(fieldErrors.location) ||
  hasConcessionFilterCategoryFieldErrors(fieldErrors.cuisine) ||
  hasConcessionFilterCategoryFieldErrors(fieldErrors.dietary)

export const validateConcessionFiltersAdmin = ({
  locationSections = [],
  cuisineOptions = [],
  dietaryOptions = []
} = {}) => {
  const fieldErrors = getConcessionFiltersAdminFieldErrors({
    locationSections,
    cuisineOptions,
    dietaryOptions
  })

  if (hasConcessionFiltersAdminFieldErrors(fieldErrors)) {
    return {
      isValid: false,
      message: GENERIC_CONCESSION_VALIDATION_ERROR,
      fieldErrors
    }
  }

  return { isValid: true, fieldErrors }
}
